export default "__VITE_ASSET__36647fbb__"